/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

const NetworkCorrelationId = {
  NetworkPageSearch: 'NetworkPageSearch',
  SuggestLinkSearch: 'SuggestLinkSearch',
  MyCompaniesSearch: 'MyCompaniesSearch'
};

export default NetworkCorrelationId;